<template>
  <v-flex>
    <v-card :color="'rgb(250, 250, 250)'" class="elevation-0">
      <v-toolbar dense :color="colorBarraFormulario" dark flat>
        <v-spacer></v-spacer>
        <v-toolbar-title v-bind:style="{ color: colorFondo300 }">
          <h5 v-bind:style="{ color: 'white' }">RESERVA</h5>
        </v-toolbar-title>
        <v-spacer></v-spacer>
      </v-toolbar>
      <v-card-text>
        <v-row class="ml-2 mt-2">
          <span>
            {{ "Fecha inicio: " + modelReserva.fecha_inicial.substring(0, 10) }}
          </span>
        </v-row>

        <v-row class="ml-2">
          <span>
            {{ "Fecha final: " + modelReserva.fecha_final.substring(0, 10) }}
          </span>
        </v-row>

        <v-row class="mt-2 ml-2">
          <span>
            {{ "Entrega: " + modelReserva.ubicacion_inicial }}
          </span>
        </v-row>

        <v-row class="ml-2 mt-2">
          <span>
            {{ "Recogida: " + modelReserva.ubicacion_final }}
          </span>
        </v-row>

        <v-row class="ml-2 mt-4">
          <span>
            {{ "Bicis S: " + modelReserva.cant_bicis_s }}
          </span>
        </v-row>
        <v-row class="ml-2 mt-2">
          <span>
            {{ "Bicis M: " + modelReserva.cant_bicis_m }}
          </span>
        </v-row>
        <v-row class="ml-2 mt-2">
          <span>
            {{ "Bicis L: " + modelReserva.cant_bicis_l }}
          </span>
        </v-row>
        <v-row class="ml-2 mt-2">
          <span>
            {{ "Bicis XL: " + modelReserva.cant_bicis_xl }}
          </span>
        </v-row>
        <v-row class="ml-2 mt-2">
          <span>
            {{ "Bicis MM: " + modelReserva.cant_bicis_mm }}
          </span>
        </v-row>
        <v-row class="ml-2 mt-2">
          <span>
            {{ "Bicis ML: " + modelReserva.cant_bicis_ml }}
          </span>
        </v-row>


        <v-row class="ml-2 mt-6 mb-2">
          <v-chip
            class="py-2 px-4"
            small
            :color="'blue-grey'"
            label

          >
            <span class="" v-bind:style="{ color: 'white' }">
              {{ "" + _captionBicisNumero() }}
            </span>
          </v-chip>
        </v-row>

        <v-row v-if="modelReserva.observaciones != null && modelReserva.observaciones != ''"  class="ml-2 mr-2 mt-2 mb-4">
          <span style="font-weight: bold; font-size: 16px;">
            {{ modelReserva.observaciones }}
          </span>
        </v-row>

        <v-divider class="ml-2 mt-2 mb-2"></v-divider>

        <v-row class="ml-2 mt-4">
          <span>
            {{ "Nombre: " + modelReserva.cliente.nombre }}
          </span>
        </v-row>
        <v-row class="ml-2">
          <span>
            {{ "Teléfono: " + modelReserva.cliente.telefono != null ? modelReserva.cliente.telefono : '' }}
          </span>
        </v-row>
        <v-row class="ml-2">
          <span>
            {{ "Email: " + (modelReserva.cliente.email != null ? modelReserva.cliente.email : '')}}
          </span>
        </v-row>
        <v-row class="ml-2">
          <span>
            {{ "Domicilio: " + (modelReserva.cliente.domicilio != null ? modelReserva.cliente.domicilio : '')}}
          </span>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-chip
          class="mt-6 mb-4 px-10"
          style="width: 240px; height: 40px"
          :color="'green'"
          @click="_cerrar"
        >
          <h3 class="ml-12" v-bind:style="{ color: 'white' }">CERRAR</h3>
        </v-chip>
        <v-spacer />
      </v-card-actions>
    </v-card>
  </v-flex>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";

var pdfMake = require("pdfmake/build/pdfmake.js");
var pdfFonts = require("pdfmake/build/vfs_fonts.js");
pdfMake.vfs = pdfFonts.pdfMake.vfs;

export default {
  name: "ReservaFormulario",
  components: {},
  data: () => ({
    loading: false,
    loadingDisponibilidad: false,
    date1: false,
    date2: false,

    incluirTransporte: true,
    showConfirmacionEliminacion: false,

    importe_s: "0.00",
    importe_m: "0.00",
    importe_l: "0.00",
    importe_xl: "0.00",

    fianza: "0.00",

    dialogBusquedaClientes: false,
    dialogCamposFactura: false,
    campoFacturaDescripcionAlquiler: "",
    campoFacturaDescripcionTransporte: "",
  }),

  props: {
    modelReserva: {
      type: Object,
      required: true,
    },

    accion: {
      type: String,
      required: true,
    },
  },

  computed: {
    ...mapState([
      "drawer",
      "dark",

      "colorEBikeAccent1",
      "colorEBikeBarraFormulario",

      "puntosDevolucion",

      "colorFondo500",
      "colorFondo400",
      "colorFondo300",
      "colorFondo200",
      "colorFondo100",

      "colorFront500",
      "colorFront400",
      "colorFront300",
      "colorFront200",
      "colorFront100",

      "colorAccent2",
      "colorAccent1",
      "colorBarraFormulario",
    ]),
    ...mapState("auth", [
      "user",
      "date",
      "access_token",
      "error",
      "errorMessage",
    ]),
    ...mapState("tarifas", [
      "tarifas",
      "tarifaSelec",
      "tarifaMenosDe7",
      "tarifaMenosDe7SinIVA",
      "tarifaMenosDe7Agencia",

      "tarifaMasDe7",
      "tarifaMasDe7SinIVA",
      "tarifaMasDe7Agencia",

      "tarifaSEUR",
      "tarifaKm",
      "tarifaFianza",
    ]),
    ...mapState("estados", ["estados"]),
    ...mapState("mensajes", ["mensajes"]),
    ...mapState("clientes", ["clientes"]),
    ...mapState("disponibilidad", [
      "disponibilidad_S",
      "disponibilidad_M",
      "disponibilidad_L",
      "disponibilidad_XL",
    ]),
    ...mapState("reportes", [
      "presupuestoImagen1",
      "presupuestoImagen2",
      "presupuestoImagen3",
      "presupuestoImagen4",
      "presupuestoImagen5",
      "presupuestoImagen6",
      "presupuestoImagen7",
      "presupuestoImagen8",
      "imagenFirma",
    ]),

    _calculoCantDias() {
      if (
        this.modelReserva.fecha_inicial != null &&
        this.modelReserva.fecha_final != null &&
        this.modelReserva.fecha_inicial <= this.modelReserva.fecha_final
      ) {
        const date1Str = new Date(this.modelReserva.fecha_inicial);
        const date2Str = new Date(this.modelReserva.fecha_final);
        const diffTime = Math.abs(date2Str - date1Str);
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        this.modelReserva.cant_dias = diffDays + 1;
        return diffDays + 1;
      }
      this.modelReserva.cant_dias = 0;
      return "-";
    },

    _calculoTarifaSelec() {
      if (this.modelReserva.cant_dias > 0 && this.modelReserva.cant_dias <= 7) {
        if (this.modelReserva.descuento_agencia) {
          this.modelReserva.precio = this.tarifaMenosDe7Agencia;
          return this.modelReserva.precio;
        }
        if (this.modelReserva.sin_iva) {
          this.modelReserva.precio = this.tarifaMenosDe7SinIVA;
          return this.modelReserva.precio;
        }
        this.modelReserva.precio = this.tarifaMenosDe7;
        return this.modelReserva.precio;
      } else if (this.modelReserva.cant_dias > 7) {
        if (this.modelReserva.descuento_agencia) {
          this.modelReserva.precio = this.tarifaMasDe7Agencia;
          return this.modelReserva.precio;
        }
        if (this.modelReserva.sin_iva) {
          this.modelReserva.precio = this.tarifaMasDe7SinIVA;
          return this.modelReserva.precio;
        }
        this.modelReserva.precio = this.tarifaMasDe7;
        return this.modelReserva.precio;
      }
      this.modelReserva.precio = 0;
      return "-";
    },

    maxCantBicisS() {
      return this.disponibilidad_S.filter(
        (e) => e.ocupada == false && e.en_reparacion == false
      ).length;
    },

    maxCantBicisM() {
      return this.disponibilidad_M.filter(
        (e) => e.ocupada == false && e.en_reparacion == false
      ).length;
    },

    maxCantBicisL() {
      return this.disponibilidad_L.filter(
        (e) => e.ocupada == false && e.en_reparacion == false
      ).length;
    },

    maxCantBicisXL() {
      return this.disponibilidad_XL.filter(
        (e) => e.ocupada == false && e.en_reparacion == false
      ).length;
    },

    currentTarifaKm: {
      get() {
        return this.tarifaKm;
      },
      set(value) {
        this.setTarifaKm(value);
      },
    },
  },

  watch: {
    modelReserva() {
      
    },

    "modelReserva.sin_iva": function () {
      this.modelReserva.precio = this._calculoTarifaSelec;
      
    },

    "modelReserva.descuento_agencia": function () {
      this.modelReserva.precio = this._calculoTarifaSelec;
      
    },
  },

  mounted() {
  
  },

  methods: {
    ...mapActions("reservas", [
      "getReservas",
      "crearReserva",
      "updateReserva",
      "eliminarReserva",
      "asignarNumeroFactura",
    ]),
    ...mapActions("clientes", ["getClientes"]),
    ...mapActions("disponibilidad", ["getDisponibilidad"]),
    ...mapMutations("disponibilidad", [
      "setDisponibilidad_S",
      "setDisponibilidad_M",
      "setDisponibilidad_L",
      "setDisponibilidad_XL",
      "setSelecBici",
      "updateSeleccionadasEditar",
    ]),
    ...mapActions("reportes", [
      "reportePresupuesto",
      "reporteConfirmacion",
      "reporteFactura",
    ]),

    ...mapMutations("tarifas", ["setTarifaKm"]),

    _cerrar() {
      this.$emit("cerrar");
    },

    _captionBicisNumero() {
      let res = "[";
      for (let index = 0; index < this.modelReserva.bicis.length; index++) {
        res =
          res +
          this.modelReserva.bicis[index].talla +
          this.modelReserva.bicis[index].numero.toString() +
          ", ";
      }
      return res.slice(0, -2) + "]";
    },

    _colorDisponibilidad(bici) {
      if (bici.seleccion) {
        return "#2979FF"; //azul fuerte
      }
      if (bici.en_reparacion) {
        return "#F44336"; //rojo fuerte
      }
      if (bici.presupuestada) {
        return "#FFFF00"; //amarillo fuerte
      }
      if (bici.ocupada) {
        return "#43A047"; //verde fuerte
      }
      return "blue-grey lighten-4";
    },

    
    _captionFecha(fecha) {
      if (fecha) {
        return (
          fecha.substring(8, 10) +
          "/" +
          fecha.substring(5, 7) +
          "/" +
          fecha.substring(0, 4)
        );
      } else {
        return "";
      }
    },

  

 
    
    
  },
};
</script>
